import { MockPath } from "@library/common/http/mock-path.mock";
import { MockMaintenanceListPortal } from "./maintenance.mock";

export const MaintenanceRoutes: MockPath<unknown>[] = [
    {
        path: 'maintenance/list-portals',
        verb: 'GET',
        collection: _ => MockMaintenanceListPortal(),
    },
];
